/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable max-len */
import React, {useState} from 'react'
import { motion } from 'framer-motion'
import { baseURL, CDN } from '../../../constants';
import 'react-single-image-viewer/dist/index.css'
import ImageGallery from 'react-image-gallery';
import "pure-react-carousel/dist/react-carousel.es.css";
import "react-image-gallery/styles/css/image-gallery.css"; // requires a loader



const Resource = ({resourceList, setResourceList, setVideoplayerPopup, videoPlayerPopup, setSelectedResource, selectedResource, setimageViewer, imageviewer}) => {
    const [imageUrl, setimageUrl] = useState('');

    const obj={
        original: imageUrl,
        thumbnail: imageUrl,
    }
    let images = [obj]

    // const imageUrl = Product.IMAGE_NAME?`${CDN}/product-images/${Product.IMAGE_NAME}`:'/images/gen.png';

    const animations = {
        initial: { opacity: 0.5, x: -10 },
        animate: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: 0 }
    }
    return (

        <motion.div
            variants={animations}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.5 }}>
            <div className="flex flex-wrap -mx-1 mt-7">
                {resourceList.map((resource, idx) => (
                    <div className="lg:w-1/4 md:w-1/3 sm:w-1/2 w-full px-1 mb-2" data-bs-toggle="modal" data-bs-target="#videoModal" key={idx}>
                        <div className="w-full border-2 border-[#E9EDF4] p-2.5 rounded-lg cursor-pointer">
                            <div className="overflow-hidden w-full rounded-lg h-[210px]" >
                                {["jpg", "gif", "png", "svg", "jpeg", "jfif", "pjpeg", "pjp", "webp"].includes(resource.document.split(".")[resource.document.split(".").length-1])
                                    ? 
                                    (<div onClick={() => {setimageViewer(true); setimageUrl(`${CDN}/${resource.document}`)}}>
                                        <motion.img 
                                            initial={{ opacity: 0, scale: 0.6 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{
                                                duration: 0.8,
                                                delay: 0.5,
                                                ease: [0, 0.71, 0.2, 1.01],
                                            }} 
                                            className="hover:scale-[115%] transition-all cursor-pointer w-full"
                                            src={`${CDN}/${resource.document}`}alt="img" loading="eager"                                         
                                        />
                                        {/* {imageviewer 
                                            && 
                                            <div>
                                                (<ImageGallery 
                                                    items={images}
                                                    showBullets={false}
                                                    showPlayButton={false}
                                                    showNav={false}
                                                    originalHeight={370}
                                                    showFullscreenButton={resource.document.length===0 ?true:false}
                                                />
                                                )
                                            </div>} */}
                                    </div>)
                                    : ["csv", "pdf", "pptx", "excel"].includes(resource.document.split(".")[resource.document.split(".").length-1]) ? 
                                        
                                        // <iframe
                                        //     src={`${CDN}/${resource.document}`}
                                        // >                         
                                        // </iframe>  
                                        <motion.img 
                                            initial={{ opacity: 0, scale: 0.6 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{
                                                duration: 0.8,
                                                delay: 0.5,
                                                ease: [0, 0.71, 0.2, 1.01],
                                            }} 
                                            className="hover:scale-[115%] transition-all cursor-pointer w-full"
                                            src='/images/resources-img2.png' alt="img" loading="eager"
                                        
                                        />                           
                                        :<>
                                            <div className='relative'>
                                                <video className="hover:scale-[115%] transition-all cursor-pointer w-full">
                                                    <source src={`${CDN}/${resource.document}`} type={resource.document_type} />
                                                </video>
                                                <img onClick={() => {setVideoplayerPopup(true); setSelectedResource(resource)}} 
                                                    src="/images/playbutton.svg" alt="icon" 
                                                    className='absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] cursor-pointer' />
                                            </div>
                                        </>
                                }
                            </div>
                            <p className="text-center sm:pt-2.5 sm:text-xl text-base font-semibold more-lines2">{resource.title}</p>
                            <p className="text-center sm:pt-2.5 pt-1.5 sm:text-xs6 text-xs2 font-normal text-[#808285]">{resource.resource_category_name}</p>
                            <button
                                onClick={() => {
                                    window.open(`${CDN}/${resource.document}`, '_blank');
                                }} 
                                type="button"
                                className="sm:mt-2.5 mt-1.5 bg-[#555259] sm:text-base text-xs6 font-semibold text-[#ffffff] rounded-lg w-full sm:py-[10px] py-2">
                                Download
                            </button>
                        </div>
                    </div>
                ))} 
            </div>  
        </motion.div>   
    )
}

export default Resource
